import { Badge } from '@chakra-ui/react'

export const SpecialtyTag = ({
  label,
  colorPalette = 'purple',
}: {
  label: string
  colorPalette?: string
}) => (
  <Badge colorPalette={colorPalette} paddingX={2.5} paddingY={1} textStyle={'label2xs'} variant={'subtle'}>
    {label}
  </Badge>
)
